import { Accordion as ChakraAccordion, AccordionProps as ChakraAccordionProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import DisplayNames from './enums';

import { forwardRef } from 'system';

const propTypes = {
  isFlush: PropTypes.bool,
  allowMultiple: PropTypes.bool,
  allowToggle: PropTypes.bool
};

export const defaultProps = {
  isFlush: false,
  allowMultiple: true,
  allowToggle: true
};

export type AccordionProps = ChakraAccordionProps & {
  isFlush?: boolean;
};

const Accordion = forwardRef(
  (props: AccordionProps, ref: React.MutableRefObject<HTMLDivElement>): React.ReactElement => {
    const { children, isFlush, ...rest } = props;
    const variant = isFlush ? 'flush' : 'default';

    return (
      <ChakraAccordion {...rest} ref={ref} variant={variant}>
        {children}
      </ChakraAccordion>
    );
  }
);

Accordion.displayName = DisplayNames.Accordion;
Accordion.propTypes = propTypes;
Accordion.defaultProps = defaultProps;

export default Accordion;
